export const SPECIALITY_TYPES = [
  { id: 'medical', name: 'Medico' },
  { id: 'support', name: 'Soporte' },
  { id: 'commercial', name: 'Commercial' },
]
